// extracted by mini-css-extract-plugin
module.exports = {"Container":"Pagination_Container__1YwNy","PageNumber":"Pagination_PageNumber__HD1r1","Active":"Pagination_Active__DVRsi"};